import { ACCOUNTS_ACCESS } from '../../server/src/routes/app/src/getTypeAccess.js';
import { getFormTypeAccess } from './getFormTypeAccess.js';

export const ID_TOKEN = 'id_token';
export const ACCESS_TOKEN = 'access_token';
export const TOKEN_TYPE = 'token_type';

export function isAccountsAccess() {
  return getFormTypeAccess() === ACCOUNTS_ACCESS;
}
